import { render, staticRenderFns } from "./SocketIo.vue?vue&type=template&id=3e09387c&scoped=true&"
import script from "./SocketIo.vue?vue&type=script&lang=js&"
export * from "./SocketIo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09387c",
  null
  
)

export default component.exports